export default __webpack_public_path__ + "static/media/lucsok.b63edd91.png";